<app-acd-steps [setCRNo]="crNo" [setCRStatus]="crDetails?.status ?? ''" [setStepDetails]="stepDetails">
</app-acd-steps>
<div *ngIf="defineView">
    <app-acd-define></app-acd-define>
</div>

<div *ngIf="searchView && isUserHaveAccess">
    <app-acd-search [setCRNo]="crNo" [buildType]="buildType" (stepNavigateTo)="viewEnable($event)"></app-acd-search>
</div>

<div id="allBuildViews" *ngIf="buildView">
    <app-acd-jp-build *ngIf="buildType == 'JobPlan'" [setCRNo]="crNo" [setCrDetails]="crDetails"
        (stepNavigateTo)="viewEnable($event)"></app-acd-jp-build>
    <app-acd-mwo-build *ngIf="buildType == 'MWO'" [setCRNo]="crNo" [setCrDetails]="crDetails"
        (stepNavigateTo)="viewEnable($event)"></app-acd-mwo-build>
    <app-acd-pm-build *ngIf="buildType == 'PM'" [setCRNo]="crNo" [setCrDetails]="crDetails"
        (stepNavigateTo)="viewEnable($event)"></app-acd-pm-build>
    <app-acd-epl-build *ngIf="buildType == 'EPL'" [setCRNo]="crNo" [setCrDetails]="crDetails"
        (stepNavigateTo)="viewEnable($event)"></app-acd-epl-build>
</div>

<div *ngIf="summaryView">
    <app-acd-summary [setCRNo]="crNo" [setCrDetails]="crDetails"></app-acd-summary>
</div>